import React from 'react';
import classNames from 'classnames';
import { pingAnalyticsUrl} from '../../../actions/actions';
import TackySweaterImage from '../../../images/tickets/TackySweater.png'
import scratchers from '../../../scratchers';

const removeRelativePath = (url) => {

}

const Results = ({ view, changeView, restartQuiz, scratcherChoice, viewDetail, personality }) =>  {

  const resultsClass = classNames({
    'scene': true,
    'scene--results': true,
    'scene--hidden': view !== 'results'
  });

  const handleRestart = e => {
    e.preventDefault();
    restartQuiz();
  }

  const handleClick = (e, view) => {
    e.preventDefault();
    changeView(view);
  }

  const detailClick = (e, slug) => {
    e.preventDefault();
    viewDetail(slug);
  }

  // get winning scratcher from sorted list of scratcher count
  const pos = scratchers.findIndex(scratcher => scratcher.slug === scratcherChoice[0].slug);
  const winningScratcher = scratchers[pos];

  // constructs sentence about personality ASSUMING there are 7 questions
  // TODO: selects 3 random numbers below questionCount to generate sentence
  const gameType = winningScratcher.slug === 'raffle' ? 'ticket' : '<em>Scratcher</em>';
  const personalitySentence = `This ${gameType} makes a great gift for someone who ${personality[0]}, ${personality[3]}, and ${personality[6]}.`;

  // Facebook sharing functionality
  const facebookShare = (e) => {
    pingAnalyticsUrl('953926');
    e.preventDefault();

    window.FB.ui({
      method: 'share_open_graph',
      action_type: 'og.shares',
      action_properties: JSON.stringify({
        object:{
          'og:url': 'https://www.givethegiftofgames.com/', // your url to share
          'og:title': 'Give the Gift of Games',
          'og:description': `${winningScratcher.name} is the perfect gift for me. Take the Gift Finder Quiz now to find the gift that’s right for you!`,
          'og:image': `https://www.givethegiftofgames.com${winningScratcher.ogImage}`
        }
      })
    }, function(response){
      // Debug response (optional)
      // google analytics share event
      window.ga('send', 'event', 'social', 'facebook');
    });
  }

  const twitterShare = e => {
    pingAnalyticsUrl('953926');
    const link = `https://GiveTheGiftofGames.com`;
    const sentence = encodeURIComponent(`${winningScratcher.name} is the perfect gift for me. Go to ${link} now to find the gift that’s right for you!`);
    const url = `https://twitter.com/intent/tweet?text=${sentence}&hashtags=GiveTheGiftOfGames`
    window.ga('send', 'event', 'social', 'twitter');
    var win = window.open(url, '_blank');
    win.focus();
  }

  return (
    <div className={resultsClass}>
        <div className="scene__content">
            <div className="scene__content-left">
                <h1 className="scene__tagline"><small><span>Your perfect gift is:</span></small> {winningScratcher.name}</h1>
                <div className="results-mobile">
                    <img className="results__mobile-ticket" src={winningScratcher.image} />
                    <a onClick={e => detailClick(e, winningScratcher.slug)} className="scene__link" href="" dangerouslySetInnerHTML={{__html: winningScratcher.slug !== 'raffle' ? 'View <tspan>Scratcher</tspan> Info' : 'View Ticket Info'}}></a>
                </div>
                <p className="scene__p" dangerouslySetInnerHTML={{__html: personalitySentence}}></p>
                <p className="scene__p"><small>Let your friends and family know what they should get you this year!</small></p>
                <div className="columns columns--2col">
                    <div className="columns__column">
                        <a onClick={ e =>facebookShare(e)} className="button button--facebook" href="#">Share this Gift <svg viewBox="0 0 18 18"><use xlinkHref="#icon-facebook"></use></svg></a>
                    </div>
                    <div className="columns__column">
                        <a onClick={ e =>twitterShare(e)} className="button button--twitter" href="#">Share this Gift <svg viewBox="0 0 18 18"><use xlinkHref="#icon-twitter"></use></svg></a>
                    </div>
                </div>
                <hr className="scene__hr" />
                <p className="scene__p"><small><small>If you can't wait until the holidays, find a retailer now!</small></small></p>
                <div className="columns">
                    <div className="columns__column">
                        <a className="button button--white button--small" target="_blank" href="https://valottery.com/wheretoplay.aspx">Find a Retailer</a>
                    </div>
                </div>
            </div>
            <div className="scene__content-right">
                <svg className="tickets" version="1.1" x="0px" y="0px" viewBox="0 0 793.3 819.9" style={{enableBackground:'new 0 0 793.3 819.9'}}>
                    <image x={winningScratcher.x} y={winningScratcher.y} xlinkHref={winningScratcher.image} width={winningScratcher.width} height={winningScratcher.height} filter="url(#ticket-shadow)" />

                    <g display="none">
                        <a xlinkHref="#" onClick={ e =>facebookShare(e)} className="tickets__share tickets__share--facebook">
                            <use xlinkHref="#icon-facebook" x="45%" y="750" width="40" height="40"></use>
                        </a>
                        <a onClick={ e =>twitterShare(e)} xlinkHref="#"  className="tickets__share tickets__share--twitter" >
                            <rect x="55%" y="750"  width="40" height="40" fill="transparent"/>
                            <use xlinkHref="#icon-twitter--box" x="53%" y="750"  width="40" height="40"></use>
                        </a>
                    </g>
                    <a onClick={e => detailClick(e, winningScratcher.slug)} href="" className="wreath__link">
                      <text className="wreath__link" textAnchor="middle" x="396.65" y="750" dangerouslySetInnerHTML={{__html: winningScratcher.slug !== 'raffle' ? 'View <tspan>Scratcher</tspan> Info' : 'View Ticket Info'}}></text>
                    </a>
                </svg>
            </div>
        </div>
    </div>
  );
}

export default Results;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Results/Results.js
 **/